/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';


const ParserLoadingCard = () => (
  <div className={styles.card}>
    <i className="fa fa-spinner fa-spin fa-3x" />
  </div>
);

export default ParserLoadingCard;




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserLoadingCard/index.jsx